import request from "@/utils/request";

export function getAnnouncementList(params) {
  return request({
    url: "/news/announcements/",
    method: "get",
    params,
  });
}

export function getAnnouncementById(params, id) {
  return request({
    url: "/news/announcements/" + id + "/",
    method: "get",
    params,
  });
}

export function getPressReleaseList(params) {
  return request({
    url: "/news/press_releases/",
    method: "get",
    params,
  });
}

export function getPressReleaseById(params, id) {
  return request({
    url: "/news/press_releases/" + id + "/",
    method: "get",
    params,
  });
}

export function getYearFilter() {
  return request({
    url: "/news/get_news_index_year_filter/",
    method: "get",
  });
}

export function getEventHeadlineList(params) {
  return request({
    url: "/news/event_headlines/",
    method: "get",
    params,
  });
}

export function getEventHeadlineById(params, id) {
  return request({
    url: "/news/event_headlines/" + id + "/",
    method: "get",
    params,
  });
}

export function getVideos() {
  return request({
    url: "/news/youtube_videos/",
    method: "get",
  });
}

export function getNewsInformation() {
  return request({
    url: "/news/news_information/get_default/",
    method: "get",
  });
}

export function announcementShare(id) {
  return request({
    url: "/news/announcements/" + id + "/share/",
    method: "get",
  });
}

export function eventHeadlineShare(id) {
  return request({
    url: "/news/event_headlines/" + id + "/share/",
    method: "get",
  });
}

export function pressReleaseShare(id) {
  return request({
    url: "/news/press_releases/" + id + "/share/",
    method: "get",
  });
}
